import { render } from "./index.vue?vue&type=template&id=c69ebdae&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=c69ebdae&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c69ebdae"]])

export default __exports__